export default __webpack_public_path__ + "alberta-burger-menu.54dd9fe440e409265e28.svg";